import AdminHttpService from "admin/common/adminHttpService";
import ThrowsValidationError from "common/http/throwsValidationError";
import FcmAccount from "features/fcmAccounts/fcmAccount";

export interface IFcmAccountService {
    listAccounts(merchantId: string): Promise<FcmAccount[]>
    addAccount(merchantId: string, account: string, fcmId: number): Promise<any>;
    updateAccount(merchantId: string, account: string, fcmId: number): Promise<any>;
    removeAccount(merchantId: string, account: string): Promise<any>;
}

class FcmAccountService extends AdminHttpService {

    async listAccounts(merchantId: string): Promise<FcmAccount[]> {        
        const response = await this.getClient().get<FcmAccount[]>(`/settings/v1/merchants/${merchantId}/fcm-accounts`);
        return response.data;
    }

    @ThrowsValidationError()
    async addAccount(merchantId: string, account: string, fcmId: number): Promise<any> {
        await this.getClient().post(
            `/settings/v1/merchants/${merchantId}/fcm-accounts`, 
            {
                accountNumber: account,
                fcmId: fcmId
            });
    }

    @ThrowsValidationError()
    async updateAccount(merchantId: string, account: string, fcmId: number): Promise<any> {
        await this.getClient().put(
            `/settings/v1/merchants/${merchantId}/fcm-accounts/${account}`, 
            {
                fcmId: fcmId
            });
    }

    async removeAccount(merchantId: string, account: string): Promise<any> {
        await this.getClient().delete(`/settings/v1/merchants/${merchantId}/fcm-accounts/${account}`);
    }

}

const fcmAccountService = new FcmAccountService();

export default fcmAccountService;